import { type FunctionComponent } from "react";

import { useCftSubpageConfig } from "scmp-app/components/plus/cft/content-list/hooks";
import { usePlusDetailedListingPopup } from "scmp-app/components/plus/detailed-listing-popup/hooks";

import { IndustryListItem } from "./industry-list-item";
import { Container } from "./styles";

export const PlusCftIndustryList: FunctionComponent = () => {
  const subpageConfig = useCftSubpageConfig();
  const { handleOpen: handleOpenDetailedListingPopup } = usePlusDetailedListingPopup();

  return (
    <Container>
      {subpageConfig.nodequeueItems.map((item, index) => (
        <IndustryListItem
          icon={item.icon}
          key={index}
          name={item.name}
          onClick={() =>
            handleOpenDetailedListingPopup({
              description: item.description,
              icon: item.icon,
              name: item.name,
              pgtype: "archive",
              queueName: item.queueName,
              type: "nodequeue",
            })
          }
        />
      ))}
      {subpageConfig.seriesItems.map((item, index) => (
        <IndustryListItem
          icon={item.icon}
          key={index}
          name={item.name}
          onClick={() =>
            handleOpenDetailedListingPopup({
              icon: item.icon,
              name: item.name,
              pgtype: "archive",
              seriesEntityId: item.seriesEntityId,
              type: "series",
            })
          }
        />
      ))}
    </Container>
  );
};

PlusCftIndustryList.displayName = "PlusCftIndustryList";
